import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";
import { ErrorBoundary } from 'react-error-boundary';
//Import Icons
import FeatherIcon from "feather-icons-react";

import {
  Card,
  CardBody,
  Container,
  Form,
  FormFeedback,
  Input,  
  Label,
  Modal,
  ModalBody,
  ModalHeader,
  Row,
  Col
} from "reactstrap";
import Select from "react-select";

import * as Yup from "yup";
import { useFormik } from "formik";

import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import interactionPlugin, { Draggable } from "@fullcalendar/interaction";
import BootstrapTheme from "@fullcalendar/bootstrap";
import Flatpickr from "react-flatpickr";
import listPlugin from '@fullcalendar/list';

//redux
import { useSelector, useDispatch } from "react-redux";

import BreadCrumb from "../../../Components/Common/BreadCrumb";
import DeleteModal from "../../../Components/Common/DeleteModal";

import { ToastContainer, toast } from 'react-toastify';

// Import React FilePond
import { registerPlugin } from "react-filepond";
//Simple bar
import SimpleBar from "simplebar-react";
import UpcommingEvents from './UpcommingEvents';
import "filepond/dist/filepond.min.css";
import FilePondPluginImageExifOrientation from "filepond-plugin-image-exif-orientation";
import FilePondPluginImagePreview from "filepond-plugin-image-preview";
import "filepond-plugin-image-preview/dist/filepond-plugin-image-preview.css";

import {
  getEvents as onGetEvents, 
  addNewEvent as onAddNewEvent,
  deleteEvent as onDeleteEvent,
  updateEvent as onUpdateEvent,
  fetchOEMList,
  resetCalendar,
} from "../../../slices/thunks";
import { baseURL, addEventImage } from "../../../utils/imageapi";
import { 
  createEventTickets,
  updateEventTickets,
  getEventTicketLines,
  deleteEventTickets
} from "../../../utils/calender";
import { getNfcByUid,nfcAll,nfcAdd,nfcDelete,nfcUpdate } from "../../../utils/nfc";
import { createSelector } from "reselect";  
registerPlugin(FilePondPluginImageExifOrientation, FilePondPluginImagePreview);
const Calender = () => {
  const dispatch = useDispatch();
  const [event, setEvent] = useState({});
  const [modal, setModal] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [upcommingevents, setUpcommingevents] = useState([]);
  const [isEditButton, setIsEditButton] = useState(true); 


  const [selectedStore, setSelectedStore] = useState(null);
  const [selectedEventTicket, setSelectedEventTicket] = useState(null);
  const [selectedNewDay, setSelectedNewDay] = useState();
  const [selectedEventType, setEventType] = useState(null); 
  const [nfcId, setNfcId] = useState(null);
  const [originalNfcId, setOriginalNfcId] = useState(null); // Track original NFC for comparison
  const [nfcRecordId, setNfcRecordId] = useState(null); // Track NFC record ID for updates
  const [nfcModified, setNfcModified] = useState(false); // Track if NFC has been modified
  const [originalTicketPrice, setOriginalTicketPrice] = useState(null); // Track original ticket price
  const [originalTicketCount, setOriginalTicketCount] = useState(null); // Track original ticket count
  const [isUploading, setIsUploading] = useState(false); // 新增上传状态
  
  // Safe user parsing with null checks
  const getCurrentUser = () => {
    try {
      const userData = sessionStorage.getItem("user");
      return userData ? JSON.parse(userData) : null;
    } catch (error) {
      console.error('Error parsing user data from sessionStorage:', error);
      return null;
    }
  };
  
  const [user, setUser] = useState(getCurrentUser());
  const [role, setRole] = useState(user?.role);

  // Update user and role when session changes
  useEffect(() => {
    const handleStorageChange = () => {
      const currentUser = getCurrentUser();
      setUser(currentUser);
      setRole(currentUser?.role);
    };

    // Listen for storage changes
    window.addEventListener('storage', handleStorageChange);
    
    // Also check on component mount in case session was updated
    handleStorageChange();

    return () => {
      window.removeEventListener('storage', handleStorageChange);
    };
  }, []);

  const selectLayoutState = (state) => state.Calendar;
  const selectLayoutProperties = createSelector(
    selectLayoutState,
    (calender) => ({
      events: calender?.events || [],
      isEventUpdated: calender?.isEventUpdated || false
    })
  ); 

  const errornotify = (error) => toast(error, { position: "top-center", hideProgressBar: true, closeOnClick: false, className: 'bg-danger text-white' });
  const successnotify = (message) => toast(message, { position: "top-center", hideProgressBar: true, closeOnClick: false, className: 'bg-success text-white' });
   
  // Inside your component
  const {
    events, isEventUpdated
  } = useSelector(selectLayoutProperties);

  console.log('Calendar component - events:', events);
  console.log('Calendar component - events length:', events?.length);
  console.log('Calendar component - events structure:', events?.[0]);

  useEffect(() => {
    console.log('Dispatching events fetch...');
    dispatch(onGetEvents()); 
    // new Draggable(document.getElementById("external-events"), {
    //   itemSelector: ".external-event",
    // });
  }, [dispatch]);
  


  const dateFormat = () => { 
    let d = new Date();
    var month = "" + (d.getMonth() + 1),
    day = "" + d.getDate(),
    year = d.getFullYear(),
    h = d.getHours(),
    m = d.getMinutes();
    if (month.length < 2) month = "0" + month;
    if (day.length < 2) day = "0" + day;
    if (h.length < 2) h = "0" + h;
    if (m.length < 2) m = "0" + m;
    return (( year+'-'+ month + '-' +day + ' ' + h + ":" + m).toString());
  };
  const [startDate, setStartDate] = useState(dateFormat());
  const [endDate, setEndDate] = useState(dateFormat());

  const dateformateStart =   (isoString) => {
      if (!isoString) return;
      console.log('dateformateStart called with:', isoString);
      const d = new Date(isoString);
      const isoResult = d.toISOString();
      console.log('Setting startDate to:', isoResult);
      setStartDate(isoResult); // 直接存储ISO格式
    };
  const dateformateEnd = (isoString) => { 
    if (!isoString) return;
    console.log('dateformateEnd called with:', isoString);
    const d = new Date(isoString);
    const isoResult = d.toISOString();
    console.log('Setting endDate to:', isoResult);
    setEndDate(isoResult); // 直接存储ISO格式 
  }; 



  // Monitor event changes and sync dates
  useEffect(() => {
    if (event && event.start && event.end) {
      console.log('Event changed, updating Formik values:', event);
      validation.setFieldValue('start', event.start);
      validation.setFieldValue('end', event.end);
    }
  }, [event]);

  useEffect(() => { 
    if(events != null && events.length > 0) {
      console.log('Processing events in useEffect:', events);
      console.log('Events length:', events.length);
      let list = [];
      const curDate = new Date();
      events.forEach(item => {
        console.log('Event:', item.id, 'Title:', item.title, 'Images:', item.images);
        if(new Date(item.end) >= curDate) {  // 修改为包含当前日期
          list.push(item);
        }
      });
      list.sort((a, b) => new Date(a.start) - new Date(b.start));
      console.log('Filtered upcoming events:', list);
      setUpcommingevents(list);  // 改为设置筛选后的list
    }
  }, [events]); // Removed upcommingevents from dependencies

  useEffect(() => {
    if (isEventUpdated) {
      setIsEdit(false);
      setEvent({});
      setTimeout(() => {
        dispatch(resetCalendar("isEventUpdated", false));
      }, 500);
    }
  }, [dispatch, isEventUpdated]);

  function handleSelectEventType(eventType){ 
    setEventType(eventType);
  }
  function handleSelectStore(store){
    setSelectedStore(store);
  }
  function handleSelectEventTicket(value){
    setSelectedEventTicket(value);
  }

  /**
   * Handling the modal state
   */
  const toggleModal = () => {
    if (modal) {
      setModal(false);
      setEvent(null);
      setIsEdit(false);
      setIsEditButton(true);
      // Reset date states to default when closing modal
      const defaultDate = dateFormat();
      setStartDate(defaultDate);
      setEndDate(defaultDate);
      // Clear NFC states when closing modal
      setNfcId(null);
      setOriginalNfcId(null);
      setNfcRecordId(null);
      setNfcModified(false);
      // Clear ticket states when closing modal
      setOriginalTicketPrice(null);
      setOriginalTicketCount(null);
      // Don't clear previewImage - let it persist for next edit
      // setPreviewImage(null);
    } else {
      setModal(true);
    }
  }; 
 const eventTypeList = [
  {
    options: [
      { label: "Product Launch", value: "Product Launch" },
      { label: "Store Clearance", value: "Store Clearance" },
      { label: "Black Fridday Sales", value: "Black Fridday Sales" },
      { label: "Fans Meetup", value: "Fans Meetup" },
    ],
  },
];
const eventTicketOptions = [
  { label: "Free", value: "Free" },
  { label: "Buy", value: "Buy" },
];
  const str_dt = function formatDate(date) {
    var monthNames = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];
    var d = new Date(date),
      month = "" + monthNames[d.getMonth()],
      day = "" + d.getDate(),
      year = d.getFullYear();
    if (month.length < 2) month = "0" + month;
    if (day.length < 2) day = "0" + day;
    return [day + " " + month, year].join(",");
  };

 
  const handleDateClick = (arg) => {
    const date = arg["date"];
    console.log('handleDateClick called with date:', date);
    dateformateStart(date);
    // Also set end date to same date initially for new events
    dateformateEnd(date);
    toggleModal();
  };
  /**
   * Handling click on event on calendar
   */
  const handleEventClick = (arg) => {
    const event = arg.event;
    
    console.log('Full event object:', event);
    console.log('Event._def.extendedProps:', event._def.extendedProps);
    console.log('Event.start:', event.start);
    console.log('Event.end:', event.end);

    const st_date = event.start;
    const ed_date = event.end;
    const r_date =
      ed_date == null
        ? str_dt(st_date)
        : str_dt(st_date) + " to " + str_dt(ed_date);
  
    // Extract ticket data from event tickets array
    let ticketPrice = "";
    let ticketCount = "";
    
    if (event._def.extendedProps.event_tickets && event._def.extendedProps.event_tickets.length > 0) {
      const firstTicket = event._def.extendedProps.event_tickets[0];
      ticketPrice = firstTicket.price_cost || firstTicket.price || "";
      ticketCount = firstTicket.number_of_tickets || "";
    }
    
    // Store original ticket values for comparison
    setOriginalTicketPrice(ticketPrice);
    setOriginalTicketCount(ticketCount);
     
    setEvent({
      id: event.id, 
      title: event.title,
      start: event.start,
      end: event.end, 
      location: event._def.extendedProps.location,
      description: event._def.extendedProps.description,
      price: ticketPrice,
      number_of_tickets: ticketCount,
      datetag: r_date, 
    });
    // Set start and end dates from the event data - prioritize event.start/end over extended props
    const eventStartTime = event.start || event._def.extendedProps.start_time;
    const eventEndTime = event.end || event._def.extendedProps.end_time;
    
    console.log('Setting dates - Start:', eventStartTime, 'End:', eventEndTime);
    console.log('Event start date:', event.start);
    console.log('Event end date:', event.end);
    console.log('Extended props start_time:', event._def.extendedProps.start_time);
    console.log('Extended props end_time:', event._def.extendedProps.end_time);
    
    setStartDate(eventStartTime);
    setEndDate(eventEndTime);
    
    // Also update Formik values immediately to ensure they're in sync
    setTimeout(() => {
      validation.setFieldValue('start', eventStartTime);
      validation.setFieldValue('end', eventEndTime);
    }, 100);
    
    // Ensure we display the most recent image by sorting by creation time
    if (event._def.extendedProps.images && event._def.extendedProps.images.length > 0) {
      // Sort images by creation time (newest first) - assuming images have created_at field
      const sortedImages = [...event._def.extendedProps.images].sort((a, b) => {
        if (a.created_at && b.created_at) {
          return new Date(b.created_at) - new Date(a.created_at);
        }
        // If no created_at, try to use id as fallback (assuming higher id = newer)
        return (b.id || 0) - (a.id || 0);
      });
      
      const latestImage = sortedImages[0];
      setPreviewImage(baseURL + "/file/event/image/" + latestImage.image_url);
    } else {
      setPreviewImage("");
    }
    
    setEventType({label:event._def.extendedProps.event_type,value:event._def.extendedProps.event_type});
    setSelectedStore(event._def.extendedProps.store_id)
    setSelectedEventTicket({label:event._def.extendedProps.event_ticket,value:event._def.extendedProps.event_ticket});
    setIsEdit(true);
    setIsEditButton(false);
    getNfc(event.id);
    toggleModal();
  };
  const getNfc = async (uid) => {
    try {
      const param={
        tag_type:"event",
        assigned_id:uid,
        page:1,
        per_page:1000,
      }
      const response = await nfcAll(param);  
      if(response.status === 200){ 
       if(response.data.data.length>0){
        const nfcRecord = response.data.data[0];
        setNfcId(nfcRecord.uid);
        setOriginalNfcId(nfcRecord.uid); // Store original NFC for comparison
        setNfcRecordId(nfcRecord.id); // Store NFC record ID for updates
        setNfcModified(false); // Reset modification flag
       } else {
        setNfcId(null);
        setOriginalNfcId(null);
        setNfcRecordId(null);
        setNfcModified(false);
       }
      } 
      else{
        errornotify(response.message)
        setNfcId(null);
        setOriginalNfcId(null);
        setNfcRecordId(null);
        setNfcModified(false);
      }
    }
    catch (error) {
      console.error('Error fetching NFC data:', error); 
      setNfcId(null);
      setOriginalNfcId(null);
      setNfcRecordId(null);
      setNfcModified(false);
    }
  }
  
  const handleNfcChange = (newNfcId) => {
    console.log('handleNfcChange called with:', newNfcId);
    console.log('originalNfcId:', originalNfcId);
    console.log('Will set nfcModified to:', newNfcId !== originalNfcId);
    setNfcId(newNfcId);
    setNfcModified(newNfcId !== originalNfcId);
  };



  const updateEventNfc = async (eventId, newNfcId) => {
    try {
      console.log("updateEventNfc called with eventId:", eventId, 'newNfcId:', newNfcId);
      console.log("nfcRecordId:", nfcRecordId, "originalNfcId:", originalNfcId);
      
      // If no NFC is provided, clear any existing NFC association
      if (!newNfcId) {
        if (nfcRecordId) {
          // Delete existing NFC association
          const deleteResponse = await nfcDelete(nfcRecordId);
          if (deleteResponse.status === 200) {
            successnotify("NFC association removed successfully");
          } else {
            errornotify(deleteResponse.message || "Failed to remove NFC association");
          }
        }
        return;
      }

      // If NFC has changed or is new
      console.log("Checking if NFC has changed: newNfcId !== originalNfcId", newNfcId !== originalNfcId);
      if (newNfcId !== originalNfcId) {
        console.log("NFC has changed, processing update...");
        if (nfcRecordId && originalNfcId) {
          // Update existing NFC association using the NFC UID
          console.log("Updating existing NFC association...");
          const updateParam = {
            tag_type: "event",
            assigned_id: eventId,
            uid: newNfcId
          };
          console.log("Update params:", updateParam);
          // Use the original NFC UID for the update endpoint
          const updateResponse = await nfcUpdate(originalNfcId, updateParam);
          console.log("NFC update response:", updateResponse);
          if (updateResponse.status === 200) {
            successnotify("NFC updated successfully");
          } else {
            errornotify(updateResponse.message || "Failed to update NFC");
          }
        } else {
          // Create new NFC association
          console.log("Creating new NFC association...");
          const addParam = {
            tag_type: "event",
            assigned_id: eventId,
            uid: newNfcId
          };
          console.log("Add params:", addParam);
          const addResponse = await nfcAdd(addParam);
          console.log("NFC add response:", addResponse);
          if (addResponse.status === 200) {
            successnotify("NFC association added successfully");
          } else {
            errornotify(addResponse.message || "Failed to add NFC association");
          }
        }
      } else {
        console.log("NFC has not changed, skipping update");
      }
    } catch (error) {
      console.error('Error updating NFC:', error);
      errornotify("Failed to update NFC association");
    } finally {
      // Reset NFC states
      setNfcId(null);
      setOriginalNfcId(null);
      setNfcRecordId(null);
      setNfcModified(false);
    }
  }
  /**
   * On delete event
   */
  const handleDeleteEvent = () => {
    dispatch(onDeleteEvent(event.id));
    setDeleteModal(false);
    toggleModal();
  };
 const [file,setFile]=useState(null);
 const [previewImage, setPreviewImage] = useState(null);  // 新增预览URL状态
 const handleFileChange = (event) => {
  const selectedFile = event.target.files[0];
  if (selectedFile) {
    setFile(selectedFile);
    setPreviewImage(URL.createObjectURL(selectedFile));  // 生成预览URL
  }
};
  // 在useEffect中添加清理函数
  useEffect(() => {
    return () => {
      if (previewImage) {
        URL.revokeObjectURL(previewImage);  // 组件卸载时释放内存
      }
    };
  }, [previewImage]);
  


  const handleMainImageUpload = async (id) => { 
    console.log('handleMainImageUpload called with id:', id, 'file:', file);
     
    if (!file) {
      console.log('No file selected, skipping image upload');
      return;
    }

    setIsUploading(true);
    const formData = new FormData();
    formData.append("image", file);
    formData.append("is_main_image", 1); 
    formData.append("event_id",id); 

    try {
      console.log('Uploading image for event:', id);
      const response = await addEventImage(formData);
      console.log('Image upload response:', response);
     

      if (response.filename) {
        successnotify(response.message || "Upload main image successful.") 
        console.log('Image uploaded successfully:', response.filename);
       // setMainImageUrl(`${baseURL}/file/evnet/image/${response.filename}`); // Store uploaded image URL
      }else{
        errornotify(response.message || "Upload main image failed.")
        console.log('Image upload failed:', response.message);
      }
    } catch (error) {
      errornotify(error || "Upload main image failed.") 
      console.error('Image upload error:', error);
    } finally {
      setIsUploading(false);
    }
  };


  // events validation
  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      title: (event && event.title) || "", 
      start: (event && event.start) || "",
      end: (event && event.end) || "",
      location: (event && event.location) || "",  
      store_id: (event && event.store_id) || "", // 新增store_id
      description: (event && event.description) || "",  
      price: (event && event.price) || "",
      number_of_tickets: (event && event.number_of_tickets) || "",
      defaultDate: event?(event.defaultDate?event.defaultDate :[]):[],  
    },

    validationSchema: Yup.object({
      title: Yup.string().required("Please Enter Your Event Name"),
      event_type: Yup.string().required("Please Select Your Event Type"),
      start: Yup.string().required("Please Select Start Date"),
      end: Yup.string()
      .required("plase select end date")
      .test(
        "is-after-start",
        "end time must be after start time",
        function(value) {
          const startDate = this.parent.start;
          return !startDate || !value || new Date(value) >= new Date(startDate);
        }
      ),
      price: Yup.number()
        .typeError("Price must be a number")
        .positive("Price must be positive")
        .nullable(),
      number_of_tickets: Yup.number()
        .typeError("Number of tickets must be a number")
        .positive("Number of tickets must be positive")
        .integer("Number of tickets must be a whole number")
        .nullable(),
    }),
    onSubmit: (values) => {
      handleAddEvent(values);
    },
  });

  const handleAddEvent = async (values) => {
    console.log('handleAddEvent called with values:', values);
    console.log('isEdit:', isEdit);
    console.log('current nfcId:', nfcId);
    console.log('originalNfcId:', originalNfcId);
    console.log('nfcModified:', nfcModified);
    console.log('State dates - startDate:', startDate, 'endDate:', endDate);
    console.log('Formik dates - start:', values.start, 'end:', values.end);
    console.log('Event object in handleAddEvent:', event);
    
    // Get current user's OEM ID
    const currentUser = getCurrentUser();
    const userOemId = currentUser?.oem_id || null;
    
    try { 
      if (isEdit) { 
        // Use Formik values as primary source, fall back to event object, then state values
        const finalStartDate = values.start || (event && event.start) || startDate;
        const finalEndDate = values.end || (event && event.end) || endDate;
        
        console.log('=== DATE DEBUGGING ===');
        console.log('values.start:', values.start);
        console.log('values.end:', values.end);
        console.log('event.start:', event && event.start);
        console.log('event.end:', event && event.end);
        console.log('startDate:', startDate);
        console.log('endDate:', endDate);
        console.log('Final dates being sent - start:', finalStartDate, 'end:', finalEndDate);
        console.log('Are dates the same?', finalStartDate === finalEndDate);
        if (finalStartDate === finalEndDate) {
          console.error('WARNING: Start and end dates are the same!');
          console.log('Original event start:', event.start);
          console.log('Original event end:', event.end);
        }
        
        const updateEvent = {
          id: event.id,
          title: values["title"],
          start: finalStartDate,
          end: finalEndDate, 
          store_id: values.store_id || null,
          location: values["location"],
          event_type: selectedEventType.value || null,
          description: values["description"],
          oem_id: userOemId, // Use logged-in user's OEM ID
        };
        // update event 
        console.log('Updating event with data:', updateEvent);
        const response = await dispatch(onUpdateEvent(updateEvent)).unwrap();     
        console.log('Event update response:', response);
        console.log('Response status:', response.status);
        console.log('Response statusCode:', response.statusCode);
        console.log('Response data:', response.data);
        console.log('Response success:', response.success);
        console.log('Response type:', typeof response);
        console.log('Response keys:', Object.keys(response));
        
        // Check multiple possible success conditions
        const isSuccess = response.status === 200 || 
                         response.statusCode === 200 || 
                         response.success === true ||
                         (response.data && response.data.success === true);
        
        console.log('Is success condition met:', isSuccess);
        
        if (isSuccess) {
          successnotify("event update successfully");
          
          // Get the event ID from response
          const eventId = response.data?.data?.id || response.data?.id || event.id;
          console.log('Extracted eventId:', eventId);
          
          // Handle image upload first
          if (file) {
            await handleMainImageUpload(eventId);
            // Add a small delay to ensure backend processes the image
            await new Promise(resolve => setTimeout(resolve, 1000));
          }
          
          // Handle event tickets - only update if values have changed
          const currentPrice = values["price"] ? parseFloat(values["price"]) : null;
          const currentCount = values["number_of_tickets"] ? parseInt(values["number_of_tickets"]) : null;
          
          const priceChanged = currentPrice !== originalTicketPrice;
          const countChanged = currentCount !== originalTicketCount;
          
          if ((currentPrice || currentCount) && (priceChanged || countChanged)) {
            const ticketData = {
              price: currentPrice,
              number_of_tickets: currentCount
            };
            console.log('Updating event tickets with data:', ticketData);
            console.log('Price changed:', priceChanged, 'Count changed:', countChanged);
            const ticketResponse = await updateEventTickets(eventId, ticketData);
            if (ticketResponse.status === 200) {
              console.log('Event tickets updated successfully');
            } else {
              console.error('Failed to update event tickets:', ticketResponse);
            }
          } else {
            console.log('No ticket changes detected, skipping ticket update');
          }
          
          // Update NFC if there are changes
          console.log('About to call updateEventNfc with eventId:', eventId, 'nfcId:', nfcId);
          await updateEventNfc(eventId, nfcId);
          
          // Refresh events list after all updates are complete
          console.log('Refreshing events list...');
          await dispatch(onGetEvents());
          console.log('Events list refreshed');
          
          toggleModal(); 
        } else { 
            errornotify(response.message || "Failed to update event. Please try again.")  
        }
        validation.resetForm();
      } else {
        // Use Formik values as primary source, fall back to event object, then state values
        const finalStartDate = values.start || (event && event.start) || startDate;
        const finalEndDate = values.end || (event && event.end) || endDate;
        
        console.log('Final dates being sent for new event - start:', finalStartDate, 'end:', finalEndDate);
        
        const newEvent = {
          id: Math.floor(Math.random() * 100),
          title: values["title"],
          start: finalStartDate,
          end: finalEndDate, 
          store_id: values.store_id || null,
          location: values["location"],
          event_type: selectedEventType.value || null,
          description: values["description"],
          oem_id: userOemId, // Use logged-in user's OEM ID
        };
        // save new event
        const response = await dispatch(onAddNewEvent(newEvent)).unwrap();     
        console.log('Add event response:', response);
        
        const isAddSuccess = response.status === 200 || 
                           response.statusCode === 200 || 
                           response.success === true ||
                           (response.data && response.data.success === true);
        
        if (isAddSuccess) {
          successnotify("event added successfully");
          
          // Get the event ID from response
          const eventId = response.data?.data?.id || response.data?.id || newEvent.id;
          console.log('Add event - Extracted eventId:', eventId);
          
          // Handle image upload first
          if (file) {
            await handleMainImageUpload(eventId);
            // Add a small delay to ensure backend processes the image
            await new Promise(resolve => setTimeout(resolve, 1000));
          }
          
          // Handle event tickets for new events
          if (values["price"] && values["number_of_tickets"]) {
            const ticketData = {
              price: parseFloat(values["price"]),
              number_of_tickets: parseInt(values["number_of_tickets"])
            };
            console.log('Creating event tickets with data:', ticketData);
            const ticketResponse = await createEventTickets(eventId, ticketData);
            if (ticketResponse.status === 200) {
              console.log('Event tickets created successfully');
            } else {
              console.error('Failed to create event tickets:', ticketResponse);
            }
          }
          
          // Add NFC association if provided
          await updateEventNfc(eventId, nfcId);
          
          // Refresh events list after all updates are complete
          console.log('Refreshing events list...');
          await dispatch(onGetEvents());
          console.log('Events list refreshed');
           
          toggleModal(); 
        } else { 
            errornotify(response.message || response.error || "Failed to add event. Please try again.")  
        }
      }
       
      
  

    } catch (err) {
      console.error('Submission failed:', err);
      errornotify(err.response?.message || 
        err.message || 
        'Failed to add product. Please check your connection and try again.') 
      
      // User-friendly error message
      
    }
  };
  const submitOtherEvent = () => {
      console.log('submitOtherEvent called - switching to edit mode');
      console.log('Current event:', event);
      console.log('Current startDate:', startDate);
      console.log('Current endDate:', endDate);
      
      document.getElementById("form-event").classList.remove("view-event");

    document
      .getElementById("event-title")
      .classList.replace("d-none", "d-block");  
      document
        .getElementById("event-nfc")
        .classList.replace("d-none", "d-block");  
        document
          .getElementById("event-price")
          .classList.replace("d-none", "d-block");  
          document
            .getElementById("number_of_tickets")
            .classList.replace("d-none", "d-block");   
    document
      .getElementById("event-start-date")
      .classList.replace("d-none", "d-flex");
      document
        .getElementById("event-end-date")
        .classList.replace("d-none", "d-flex");
    document
      .getElementById("event-location")
      .classList.replace("d-none", "d-block");
    document
      .getElementById("event-description")
      .classList.replace("d-none", "d-block");
      document
        .getElementById("event-nfc-tag")
        .classList.replace("d-block", "d-none");
    document
      .getElementById("event-start-date-tag")
      .classList.replace("d-block", "d-none");
    document
      .getElementById("event-location-tag")
      .classList.replace("d-block", "d-none");
    document
      .getElementById("event-description-tag")
      .classList.replace("d-block", "d-none");
    // document.getElementById("btn-save-event").removeAttribute("hidden");
    setIsEditButton(true);
    
    // Ensure Formik values are properly set when switching to edit mode
    if (event && event.start && event.end) {
      console.log('Setting Formik values - start:', event.start, 'end:', event.end);
      // Use setTimeout to ensure DOM updates are complete before setting values
      setTimeout(() => {
        console.log('Setting Formik values with delay - start:', event.start, 'end:', event.end);
        validation.setFieldValue('start', event.start);
        validation.setFieldValue('end', event.end);
      }, 100);
    }
  };

  /**
   * On category darg event
   */
  const onDrag = (event) => {
    event.preventDefault();
  };

  /**
   * On calendar drop event
   */
  const onDrop = (event) => {
    const date = event["date"];
    const day = date.getDate();
    const month = date.getMonth();
    const year = date.getFullYear();

    const currectDate = new Date();
    const currentHour = currectDate.getHours();
    const currentMin = currectDate.getMinutes();
    const currentSec = currectDate.getSeconds();
    const modifiedDate = new Date(
      year,
      month,
      day,
      currentHour,
      currentMin,
      currentSec
    );

    const draggedEl = event.draggedEl;
    const draggedElclass = draggedEl.className;
    if (
      draggedEl.classList.contains("external-event") &&
      draggedElclass.indexOf("fc-event-draggable") === -1
    ) {
      const modifiedData = {
        id: Math.floor(Math.random() * 1000),
        title: draggedEl.innerText,
        start: modifiedDate,
        className: draggedEl.className,
      };
      dispatch(onAddNewEvent(modifiedData));
    }
  };
  document.title = "Calendar | SeedNations";
  return (
    <React.Fragment>
      <DeleteModal
        show={deleteModal}
        onDeleteClick={handleDeleteEvent}
        onCloseClick={() => setDeleteModal(false)}
      />
      <div className="page-content">
        <Container fluid>
        <ToastContainer />
          <BreadCrumb title="Calendar" pageTitle="Apps" />
          <Row>
            <Col xs={12}>
              <Row>
                <Col xl={3}>
                {(role==="customer"||role==="employee1")?"": <Card className="card-h-100">
                    <CardBody>
                    <button
                        className="btn btn-primary w-100"
                        id="btn-new-event"
                        onClick={toggleModal}
                      >
                        <i className="mdi mdi-plus"></i> Create New Event
                      </button>

                      <div id="external-events">
                        <br />
                        {/* <p className="text-muted">
                          Drag and drop your event or click in the calendar
                        </p> */}
                        {/* {categories &&
                          categories.map((category, i) => (
                            <div
                            className={`bg-${category.type}-subtle external-event fc-event text-${category.type}`}
                              key={"cat-" + category.id}
                              draggable
                              onDrag={(event) => {
                                onDrag(event, category);
                              }}
                            >
                              <i className="mdi mdi-checkbox-blank-circle me-2" />
                              {category.title}
                            </div>
                          ))} */}
                      </div>
                    </CardBody>
                  </Card>}
                  <div>
                    <h5 className="mb-1 d-inline-block" style={{marginRight:'10px'}}>Upcomming Events</h5>
                    <Link to="/event" className="btn btn-sm btn-soft-primary ">all</Link>
                    
                    {upcommingevents && upcommingevents.length > 0 ? (
                      <SimpleBar
                        className="pe-2 me-n1 mb-3"
                        style={{ height: "400px" }}
                      >
                        <div id="upcoming-event-list">
                          {upcommingevents.map((event, key) => (
                            <UpcommingEvents event={event} key={key} />
                          ))}
                        </div>
                      </SimpleBar>
                    ) : (
                      <div className="mb-3">
                        <div className="text-center py-2">
                          <p className="text-muted mb-0">No upcoming events</p>
                        </div>
                      </div>
                    )}
                  </div>

                  <Card>
                    <CardBody className="bg-info-subtle">
                      <div className="d-flex">
                        <div className="flex-shrink-0">
                          <FeatherIcon
                            icon="calendar"
                            className="text-info icon-dual-info"
                          />
                        </div>
                        <div className="flex-grow-1 ms-3">
                          <h6 className="fs-15">Welcome to your Calendar!</h6>
                          <p className="text-muted mb-0">
                            Event that applications book will appear here. Click
                            on an event to see the details and manage applicants
                            event.
                          </p>
                        </div>
                      </div>
                    </CardBody>
                  </Card>
                </Col>

                <Col xl={9}>
                  <Card className="card-h-100">
                    <CardBody>
                      <FullCalendar
                        plugins={[
                          BootstrapTheme,
                          dayGridPlugin,
                          interactionPlugin,
                          listPlugin
                        ]}
                        initialView="dayGridMonth"
                        slotDuration={"00:15:00"}
                        handleWindowResize={true}
                        themeSystem="bootstrap"
                        headerToolbar={{
                          left: "prev,next today",
                          center: "title",
                          right: "dayGridMonth,dayGridWeek,dayGridDay,listWeek",
                        }}
                        events={events}
                        editable={true}
                        droppable={true}
                        selectable={true} 
                        dateClick={handleDateClick}
                        eventClick={handleEventClick}
                        drop={onDrop}
                      />
                    </CardBody>
                  </Card>
                </Col>
              </Row>

              <div style={{ clear: "both" }}></div>

              <Modal isOpen={modal} id="event-modal" centered>
                <ModalHeader toggle={toggleModal} tag="h5" className="p-3 bg-info-subtle modal-title">
                  {!!isEdit ? "Edit Event" : "Add Event"}
                </ModalHeader>
                <ModalBody>
                  <Form
                    className={
                      !!isEdit
                        ? "needs-validation view-event"
                        : "needs-validation"
                    }
                    name="event-form"
                    id="form-event"
                    onSubmit={(e) => {
                      e.preventDefault();
                      validation.handleSubmit();
                      return false;
                    }}
                  >
                    {!!isEdit && role && role!="customer" ? (
                      <div className="text-end">
                        <Link
                          to="#"
                          className="btn btn-sm btn-soft-primary"
                          id="edit-event-btn"
                          onClick={(e) => {
                            e.preventDefault();
                            submitOtherEvent();
                            return false;
                          }}
                        >
                          Edit
                        </Link>
                      </div>
                    ) :
                      null
                    }


                    <div className="event-details">
                      <div className="d-flex mb-2">
                        <div className="flex-grow-1 d-flex align-items-center">
                          <div className="flex-shrink-0 me-3">
                            <i className="ri-calendar-event-line text-muted fs-16"></i>
                          </div>
                          <div className="flex-grow-1">
                            <h6
                              className="d-block fw-semibold mb-0"
                              id="event-start-date-tag"
                            >
                              {event ? event.datetag : ""}
                            </h6>
                          </div>
                        </div>
                      </div> 
                      <div className="d-flex align-items-center mb-2">
                          <div className="flex-shrink-0 me-3">
                              <i className="ri-time-line text-muted fs-16"></i>
                          </div>
                          <div className="flex-grow-1">
                              <h6 className="d-block fw-semibold mb-0" >
                                  
                              <span id="event-nfc-tag">
                                  {nfcId? nfcId : "No NFC ID"}</span>
                              </h6>
                          </div>
                      </div>
                      <div className="d-flex align-items-center mb-2">
                        <div className="flex-shrink-0 me-3">
                          <i className="ri-map-pin-line text-muted fs-16"></i>
                        </div>
                        <div className="flex-grow-1">
                          <h6 className="d-block fw-semibold mb-0">
                            {" "}
                            <span id="event-location-tag">
                              {event && event.location !== undefined ? event.location : "No Location"}
                            </span>
                          </h6>
                        </div>
                      </div>
                      <div className="d-flex mb-3">
                        <div className="flex-shrink-0 me-3">
                          <i className="ri-discuss-line text-muted fs-16"></i>
                        </div>
                        <div className="flex-grow-1">
                          <p
                            className="d-block text-muted mb-0"
                            id="event-description-tag"
                          >
                            {event && event.description !== undefined ? event.description : "No Description"}
                          </p>
                        </div>
                      </div>
                    </div>
                    <Row className="event-form">
                      <Col xs={12}>
                      <div className="mb-4">
                    <h5 className="fs-15 mb-1">Event Image</h5>
                    <p className="text-muted">Upload the main event image.</p>
                    <div className="text-center">
                      <div className="position-relative d-inline-block">
                        <div className="position-absolute top-100 start-100 translate-middle">
                          <label htmlFor="product-image-input" className="mb-0">
                            <div className="avatar-xs">
                              <div className="avatar-title bg-light border rounded-circle text-muted cursor-pointer">
                                <i className="ri-image-fill"></i>
                              </div>
                            </div>
                          </label>
                          <input
                            className="form-control d-none"
                            id="product-image-input"
                            type="file"
                            accept="image/png, image/gif, image/jpeg"
                            onChange={handleFileChange}
                          />
                        </div>
                        <div className="avatar-lg"> 
                          <div className="avatar-title bg-light rounded">
                            {previewImage ? (
                              <img
                                src={previewImage}
                                alt="Product"
                                className="avatar-md h-auto"
                              />
                            ) : (
                              <p className="text-muted">No image selected</p>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                      </Col>
                      <Col xs={12}>
                        <div className="mb-3">
                          <Label className="form-label">Type</Label>
                          <Select
                              value={selectedEventType}
                              onChange={(selectedOption) => {
                                handleSelectEventType(selectedOption);
                              }}
                              options={eventTypeList}
                              name="choices-nft-input"
                              classNamePrefix="select2-selection form-select"
                            />
                        </div>
                      </Col>
                      <Col xs={12}>
                        <div className="mb-3">
                          <Label className="form-label">Title</Label>
                          <Input
                            className={
                              !!isEdit
                                ? "form-control d-none"
                                : "form-control d-block"
                            }
                            placeholder="Enter event name"
                            type="text"
                            name="title"
                            id="event-title"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.title || ""} 
                          />
                          {validation.touched.title &&
                            validation.errors.title ? (
                            <FormFeedback type="invalid">
                              {validation.errors.title}
                            </FormFeedback>
                          ) : null}
                        </div>
                      </Col>
                      <Col xs={12}>
                        <div className="mb-3">
                          <Label className="form-label">NFC ID</Label>
                          <Input
                            className={
                              !!isEdit
                                ? "form-control d-none"
                                : "form-control d-block"
                            }
                            placeholder="Enter event nfc"
                            type="text"
                            name="nfc"
                            id="event-nfc"
                              onChange={(e) => {
                                handleNfcChange(e.target.value);
                              }}
                            onBlur={validation.handleBlur}
                            value={nfcId || ""}
                          />
                          {validation.touched.nfc &&
                            validation.errors.nfc ? (
                            <FormFeedback type="invalid">
                              {validation.errors.nfc}
                            </FormFeedback>
                          ) : null}
                        </div>
                      </Col>

                      {/* <Col xs={12}>
                        <div className="mb-3">
                          <Label className="form-label">Event Ticket</Label>
                            <Select
                              value={selectedEventTicket}
                              onChange={(selectedOption) => {
                                handleSelectEventTicket(selectedOption);
                              }}
                              options={eventTicketOptions}
                              name="event-ticket-input"
                              classNamePrefix="select2-selection form-select"
                            />
                            </div>
                      </Col> */}
                      <Col xs={12}>
                        <div className="mb-3">
                          <Label className="form-label">Limited Registration</Label>
                        </div>
                      </Col>
                      <Col xs={6}>
                        <div className="mb-3">
                          <Label className="form-label">Price</Label>
                          <Input
                            className={`form-control ${
                              validation.touched.price && validation.errors.price ? "is-invalid" : ""
                            }`}
                            placeholder="Enter event ticket price"
                            type="text"
                            name="price"
                            id="event-price"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.price || ""} 
                          />
                          {validation.touched.price && validation.errors.price ? (
                            <FormFeedback type="invalid">{validation.errors.price}</FormFeedback>
                          ) : null}
                        </div>
                      </Col>
                      <Col xs={6}>
                        <div className="mb-3">
                          <Label className="form-label">Number of Tickets</Label>
                          <Input
                            className={`form-control ${
                              validation.touched.number_of_tickets && validation.errors.number_of_tickets ? "is-invalid" : ""
                            }`}
                            placeholder="Enter event ticket number"
                            type="text"
                            name="number_of_tickets"
                            id="number_of_tickets"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.number_of_tickets || ""}
                          />
                          {validation.touched.number_of_tickets && validation.errors.number_of_tickets ? (
                            <FormFeedback type="invalid">{validation.errors.number_of_tickets}</FormFeedback>
                          ) : null}
                        </div>
                      </Col>
                          
                      <Col xs={12}>
                        <div className="mb-3">
                          <Label className="form-label">Store</Label> 
                            <Select
                              value={
                                [{label:"Store1",value:1},{label:"Store2",value:2},{label:"Store3",value:3}]
                                  .find(opt => opt.value === validation.values.store_id) || null
                              }
                              onChange={(selectedOption) => {
                                setSelectedStore(selectedOption);
                                validation.setFieldValue("store_id", selectedOption.value);
                              }}
                              options={[{label:"Store1",value:1},{label:"Store2",value:2},{label:"Store3",value:3}]}
                              name="store_id"
                              classNamePrefix="select2-selection form-select"
                            />  
                        </div>
                      </Col>
                      <Col xs={12}>
                        <div className="mb-3">
                          <Label>Start Time </Label>
                         
                          <div id="event-start-date"
                            className={
                              !!isEdit ? "input-group d-none" : "input-group"
                            }
                          >
                              <Flatpickr
                                name="start"
                                className="form-control"
                                placeholder="Select start"
                                options={{
                                  enableTime: true,
                                  altInput: true,
                                  altFormat: "Y-m-d H:i",
                                  dateFormat: "Y-m-d H:i",
                                }}
                                onChange={(e) =>{
                                  const isoDate = e[0]?.toISOString(); // 转换为ISO格式
                                  dateformateStart(isoDate);
                                  // Update Formik value as well
                                  validation.setFieldValue('start', isoDate);
                                } }
                                value={startDate || validation.values.start || ""}
                              />
                              {validation.touched.start && validation.errors.start ? (
                                <FormFeedback type="invalid">{validation.errors.start}</FormFeedback>
                              ) : null}
                            <span className="input-group-text">
                              <i className="ri-calendar-event-line"></i>
                            </span>
                          </div>
                        </div>
                      </Col>
                      <Col xs={12}>
                        <div className="mb-3">
                          <Label>End Time </Label>
                         
                          <div  id="event-end-date" 
                            className={
                              !!isEdit ? "input-group d-none" : "input-group"
                              
                            }
                          >
                           <Flatpickr 
                                name="end"
                                placeholder="Select end"
                                className="form-control"
                                options={{
                                  enableTime: true,
                                  altInput: true,
                                  altFormat: "Y-m-d H:i",
                                  dateFormat: "Y-m-d H:i",
                                  minDate: startDate || null  // 添加最小日期限制
                                }}
                                onChange={(e) =>{
                                  const isoDate = e[0]?.toISOString();
                                  dateformateEnd(isoDate);
                                  // Update Formik value as well
                                  validation.setFieldValue('end', isoDate);
                                  // 添加实时验证
                                   
                                  if (new Date(isoDate) < new Date(startDate)) {
                                    validation.setFieldError('end', 'End time cannot be earlier than start time');
                                    return
                                  }
                                  
                                }}
                                value={endDate || validation.values.end || ""}
                              />
                              {validation.touched.end && validation.errors.end ? (
                                <FormFeedback type="invalid">
                                  {validation.errors.end === 'End time cannot be earlier than start time' 
                                    ? "end time cannot be earlier than start time"
                                    : validation.errors.end}
                                </FormFeedback>
                              ) : null}
                            <span className="input-group-text">
                              <i className="ri-calendar-event-line"></i>
                            </span>
                          </div>
                        </div>
                      </Col>
                      <Col xs={12}>
                        <div className="mb-3">
                          <Label htmlFor="event-location">Location</Label>
                          <div>
                            <Input
                              type="text"
                              className="form-control d-block"
                              name="location"
                              id="event-location"
                              placeholder="Event location"
                              onChange={validation.handleChange}
                              onBlur={validation.handleBlur}
                              value={validation.values.location }
                            />
                            {validation.touched.location &&
                              validation.errors.location ? (
                              <FormFeedback type="invalid">
                                {validation.errors.location}
                              </FormFeedback>
                            ) : null}
                          </div>
                        </div>
                      </Col>
                      <Col xs={12}>
                        <div className="mb-3">
                          <Label className="form-label">Description</Label>
                          <textarea
                            className={
                              !!isEdit
                                ? "form-control d-none"
                                : "form-control d-block"
                            }
                            id="event-description"
                            name="description"
                            placeholder="Enter a description"
                            rows="3"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.description}
                          // invalid={
                          //   validation.touched.description &&
                          //   validation.errors.description
                          //     ? true
                          //     : false
                          // }
                          ></textarea>
                          {validation.touched.description &&
                            validation.errors.description ? (
                            <FormFeedback type="invalid">
                              {validation.errors.description}
                            </FormFeedback>
                          ) : null}
                        </div>
                      </Col>
                    </Row>
                    <div className="hstack gap-2 justify-content-end">
                      {!!isEdit && role && role!="customer" && (
                        <button
                          type="button"
                          className="btn btn-soft-danger"
                          id="btn-delete-event"
                          onClick={() => setDeleteModal(true)}
                        >
                          <i className="ri-close-line align-bottom"></i> Delete
                        </button>
                      )}
                      {isEditButton && <button
                        type="submit"
                        className="btn btn-success"
                        id="btn-save-event"
                        onClick={() => {
                          handleAddEvent(validation.values); 
                        }}
                      >
                        {!!isEdit ? "Edit Event" : "Add Event"}
                      </button>}
                    </div>
                  </Form>
                </ModalBody>
              </Modal>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

Calender.propTypes = {
  events: PropTypes.any, 
  className: PropTypes.string,
  onGetEvents: PropTypes.func,

  onAddNewEvent: PropTypes.func,
  onUpdateEvent: PropTypes.func,
  onDeleteEvent: PropTypes.func, 
};

// Error Boundary Fallback Component
const CalendarErrorFallback = ({ error, resetErrorBoundary }) => (
  <div className="page-content">
    <div className="container-fluid">
      <div className="alert alert-danger" role="alert">
        <h4 className="alert-heading">Calendar Loading Error</h4>
        <p>There was an issue loading the calendar. This might be a temporary problem with event data.</p>
        <p className="mb-0">
          <button className="btn btn-outline-danger btn-sm me-2" onClick={resetErrorBoundary}>
            Try Again
          </button>
          <button className="btn btn-primary btn-sm" onClick={() => window.location.reload()}>
            Refresh Page
          </button>
        </p>
      </div>
    </div>
  </div>
);

// Wrap the entire Calendar component with ErrorBoundary
const SafeCalendar = () => (
  <ErrorBoundary
    FallbackComponent={CalendarErrorFallback}
    onError={(error, errorInfo) => {
      console.error('Calendar Component Error:', error, errorInfo);
    }}
  >
    <Calender />
  </ErrorBoundary>
);

export default SafeCalendar;
